import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie_consent';

const CookieConsent = ({ onConsent }) => {
  const { t } = useTranslation();

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    onConsent();
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    onConsent();
  };

  return (
    <motion.div
      data-testid="cookie-banner"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 24 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="fixed left-0 right-0 z-[9990] px-3 md:px-6"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 76px)' }}
    >
      <div
        className="max-w-4xl mx-auto md:mb-6"
        style={{ marginBottom: '0' }}
      >
        <div className="bg-[#111] border border-white/10 rounded-2xl shadow-2xl shadow-black/70 p-4 md:p-5"
          style={{ backdropFilter: 'blur(12px)' }}>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">

            {/* Icon + text */}
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <div className="shrink-0 w-8 h-8 rounded-lg bg-[#EAB308]/10 border border-[#EAB308]/20 flex items-center justify-center mt-0.5">
                <Cookie size={15} className="text-[#EAB308]" />
              </div>
              <p className="text-[#A3A3A3] text-xs sm:text-sm leading-relaxed">
                {t('cookies.text')}{' '}
                <Link
                  to="/politique-de-confidentialite"
                  className="text-[#EAB308] hover:underline underline-offset-2 whitespace-nowrap"
                >
                  {t('cookies.learn_more')}
                </Link>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex gap-2 shrink-0 justify-end">
              <button
                onClick={handleDecline}
                data-testid="cookie-decline-btn"
                className="text-[#555] hover:text-[#A3A3A3] text-xs font-medium px-4 py-2.5 rounded-xl border border-white/8 hover:border-white/15 transition-all duration-200 whitespace-nowrap"
              >
                {t('cookies.decline')}
              </button>
              <button
                onClick={handleAccept}
                data-testid="cookie-accept-btn"
                className="bg-[#EAB308] hover:bg-[#CA8A04] text-black text-xs font-bold px-5 py-2.5 rounded-xl transition-colors duration-200 whitespace-nowrap"
              >
                {t('cookies.accept')}
              </button>
            </div>

          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CookieConsent;
